<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <div class="link_location">
                <h2 class="Title">
                    {{ $store.getters.t('라이브') }}
                    <v-icon class="mdi mdi-chevron-right" />
                    <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('WebRTC 레코딩') }}</span>
                    </h2>
            </div>
            <!-- <h2 class="Title">
                레코딩 파일 (WebRTC)
            </h2>

            <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/webrtc/stream_recording">레코딩 파일</a>
            </div> -->
        </div>

            <WebrtcLivestreamRecordingForm />

    </div>
    
</template>
    
<script>
import WebrtcLivestreamRecordingForm from '@/components/webrtc/WebrtcLivestreamRecordingForm.vue';

export default {
    components: {
        WebrtcLivestreamRecordingForm,
    },
}
</script>

<style lang="scss" scoped></style>